import request from '@/utils/request'

// 创建赛道
export async function createSystemChannel(params: any) {
  return request('/api/v2/system/channel_save', {
    method: 'POST',
    data: params
  })
}

// 明细
export async function getSystemChannelSearch(params: any) {
  return request('/api/v2/system/channel_search', {
    method: 'GET',
    params
  })
}
// 删除赛道
export async function deleteSystemChannel(params: any) {
  return request('/api/v2/system/channel_delete', {
    method: 'POST',
    data: params
  })
}

export async function postChannelGroupSave(params: any) {
  return request('/api/v2/system/channel_group_save', {
    method: 'POST',
    data: params
  })
}

export async function getChannelGroupList(params: any) {
  return request('/api/v2/system/channel_group_search', {
    method: 'GET',
    params,
  })
}

export async function postChannelGroupDelete(params: any) {
  return request('/api/v2/system/channel_group_delete', {
    method: 'POST',
    data: params
  })
}

export async function getCurrentChannelList(params: any) {
  return request('/api/v2/system/channel_list', {
    method: 'GET',
    params
  })
}

export async function getHistoryChannel(params: any) {
  return request('/api/v2/system/channel_history_list', {
    method: 'GET',
    params
  })
}

export async function getChannelByName(params: any) {
  return request('/api/v2/system/channel_list_by_name', {
    method: 'GET',
    params
  })
}

// 获取环线列表
export async function getCircle(params: any) {
  return request('/api/v2/system/circle_list', {
    method: 'GET',
    params
  })
}
